export default __webpack_public_path__ + "static/media/MenuIcon.c3983f71.svg";